// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articlre-par-category-nom {
    text-decoration: none;
    color: var(--couleur-principale);
    font-size: var(--font-size-cat-title);
}

.articlre-par-category-title {
    font-size: var(--font-size-cat-title);
    font-weight: var(--font-weight-title);
    margin: 32px 0px;
}

.articlre-par-category-horizontal-container {
    position: relative;
    display: flex;
    align-items: center;
}

.articlre-par-category-horizontal-list>* {
    min-width: 235px;
    width: 235px;
}

.articlre-par-category-horizontal-list {
    display: flex;
    overflow-x: auto;
    scroll-behavior: smooth;
    gap: 20px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.articlre-par-category-horizontal-list.active {
    cursor: pointer;
    cursor: -webkit-grabbing;
}

.articlre-par-category-horizontal-list {
    cursor: pointer;
    cursor: -webkit-grab;
}

.articlre-par-category-arrow-button {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: var(--couleur-dark);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: absolute;
    z-index: 2;
    top: 160px;
}

.articlre-par-category-arrow-fleche {
    font-size: 24px;
}

.articlre-par-category-arrow {
    color: var(--white-principale);
    font-size: 20px;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
}

.articlre-par-category-arrow-button.left-arrow {
    left: -34px;
}

.articlre-par-category-arrow-button.right-arrow {
    right: -40px;
}

.see-more-card {
    width: 235px;
    flex: 0 0 235px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--gris-secondaire);
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-align: center;
}

.see-more-card:hover {
    background: var(--couleur-principale);
    transform: translateY(-4px);
}

.see-more-card a {
    text-decoration: none;
    color: inherit;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.see-more-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 20px;
    color: var(--couleur-dark);
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-see-more);
}

.see-more-card:hover .see-more-card-content {
    color: var(--white-principale);
}

.see-more-icon {
    color: var(--couleur-principale);
    transition: transform 0.2s ease, color 0.3s ease;
}

.see-more-card:hover .see-more-icon {
    transform: scale(1.2);
    color: var(--white-principale);
}

.articlre-par-category-pages-wrapper {
    position: relative;
    width: 100%;
    min-height: 320px;
}

.articlre-par-category-horizontal-list {
    display: flex;
    gap: 16px;
    width: 100%;
    transition: opacity 0.25s ease, transform 0.25s ease;
}

.articlre-par-category-horizontal-list.hidden-page {
    position: absolute;
    inset: 0;
    opacity: 0;
    pointer-events: none;
    transform: translateX(10px);
}

.articlre-par-category-horizontal-list.active-page {
    position: relative;
    opacity: 1;
    pointer-events: auto;
    transform: translateX(0);
}

@media (min-width: 1025px) {
    .articlre-par-category-horizontal-list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        width: 100%;
        gap: 20px;
        overflow: hidden;
    }

    .articlre-par-category-horizontal-list>* {
        min-width: unset;
        width: 100%;
    }

}

@media (max-width: 768px) {
    .articlre-par-category-title {
        font-size: 16px;
        margin: 28px 0px;
    }

    .articlre-par-category-horizontal-list {
        gap: 10px;
        grid-template-columns: repeat(5, 1fr);
        width: 100%;
        scroll-snap-type: x mandatory;
    }

    .articlre-par-category-horizontal-list>* {
        width: 162px;
        min-width: 162px;
        scroll-snap-align: start;
        flex: 0 0 auto;
    }

    .articlre-par-category-horizontal-list::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .articlre-par-category-arrow-button {
        width: 30px;
        height: 30px;
        top: 115px;
    }

    .articlre-par-category-arrow-fleche {
        font-size: 23px;
    }

    .see-more-card {
        width: 180px;
        flex: 0 0 180px;
    }
}

@media (max-width: 480px) {
    .articlre-par-category-title {
        font-size: 15px;
        margin: 24px 0px;
    }

    .see-more-card {
        width: 150px;
        flex: 0 0 150px;
    }

    .articlre-par-category-arrow-button.right-arrow {
        right: 0px;
    }

    .articlre-par-category-arrow-button.left-arrow {
        left: 0px;
    }

}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/ArticleParCategorie.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,UAAU;IACV,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,0BAA0B;IAC1B,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,gDAAgD;AACpD;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;QACb,qCAAqC;QACrC,WAAW;QACX,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,SAAS;QACT,qCAAqC;QACrC,WAAW;QACX,6BAA6B;IACjC;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,wBAAwB;QACxB,cAAc;IAClB;;IAEA;QACI,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;IACb;;AAEJ","sourcesContent":[".articlre-par-category-nom {\n    text-decoration: none;\n    color: var(--couleur-principale);\n    font-size: var(--font-size-cat-title);\n}\n\n.articlre-par-category-title {\n    font-size: var(--font-size-cat-title);\n    font-weight: var(--font-weight-title);\n    margin: 32px 0px;\n}\n\n.articlre-par-category-horizontal-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.articlre-par-category-horizontal-list>* {\n    min-width: 235px;\n    width: 235px;\n}\n\n.articlre-par-category-horizontal-list {\n    display: flex;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    gap: 20px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n}\n\n.articlre-par-category-horizontal-list.active {\n    cursor: pointer;\n    cursor: -webkit-grabbing;\n}\n\n.articlre-par-category-horizontal-list {\n    cursor: pointer;\n    cursor: -webkit-grab;\n}\n\n.articlre-par-category-arrow-button {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    background-color: var(--couleur-dark);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    position: absolute;\n    z-index: 2;\n    top: 160px;\n}\n\n.articlre-par-category-arrow-fleche {\n    font-size: 24px;\n}\n\n.articlre-par-category-arrow {\n    color: var(--white-principale);\n    font-size: 20px;\n    user-select: none;\n    display: flex;\n    align-items: center;\n}\n\n.articlre-par-category-arrow-button.left-arrow {\n    left: -34px;\n}\n\n.articlre-par-category-arrow-button.right-arrow {\n    right: -40px;\n}\n\n.see-more-card {\n    width: 235px;\n    flex: 0 0 235px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--gris-secondaire);\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    text-align: center;\n}\n\n.see-more-card:hover {\n    background: var(--couleur-principale);\n    transform: translateY(-4px);\n}\n\n.see-more-card a {\n    text-decoration: none;\n    color: inherit;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.see-more-card-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 20px;\n    color: var(--couleur-dark);\n    font-weight: var(--font-weight-medium);\n    font-size: var(--font-size-see-more);\n}\n\n.see-more-card:hover .see-more-card-content {\n    color: var(--white-principale);\n}\n\n.see-more-icon {\n    color: var(--couleur-principale);\n    transition: transform 0.2s ease, color 0.3s ease;\n}\n\n.see-more-card:hover .see-more-icon {\n    transform: scale(1.2);\n    color: var(--white-principale);\n}\n\n.articlre-par-category-pages-wrapper {\n    position: relative;\n    width: 100%;\n    min-height: 320px;\n}\n\n.articlre-par-category-horizontal-list {\n    display: flex;\n    gap: 16px;\n    width: 100%;\n    transition: opacity 0.25s ease, transform 0.25s ease;\n}\n\n.articlre-par-category-horizontal-list.hidden-page {\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    pointer-events: none;\n    transform: translateX(10px);\n}\n\n.articlre-par-category-horizontal-list.active-page {\n    position: relative;\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateX(0);\n}\n\n@media (min-width: 1025px) {\n    .articlre-par-category-horizontal-list {\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n        width: 100%;\n        gap: 20px;\n        overflow: hidden;\n    }\n\n    .articlre-par-category-horizontal-list>* {\n        min-width: unset;\n        width: 100%;\n    }\n\n}\n\n@media (max-width: 768px) {\n    .articlre-par-category-title {\n        font-size: 16px;\n        margin: 28px 0px;\n    }\n\n    .articlre-par-category-horizontal-list {\n        gap: 10px;\n        grid-template-columns: repeat(5, 1fr);\n        width: 100%;\n        scroll-snap-type: x mandatory;\n    }\n\n    .articlre-par-category-horizontal-list>* {\n        width: 162px;\n        min-width: 162px;\n        scroll-snap-align: start;\n        flex: 0 0 auto;\n    }\n\n    .articlre-par-category-horizontal-list::-webkit-scrollbar {\n        width: 0;\n        height: 0;\n    }\n\n    .articlre-par-category-arrow-button {\n        width: 30px;\n        height: 30px;\n        top: 115px;\n    }\n\n    .articlre-par-category-arrow-fleche {\n        font-size: 23px;\n    }\n\n    .see-more-card {\n        width: 180px;\n        flex: 0 0 180px;\n    }\n}\n\n@media (max-width: 480px) {\n    .articlre-par-category-title {\n        font-size: 15px;\n        margin: 24px 0px;\n    }\n\n    .see-more-card {\n        width: 150px;\n        flex: 0 0 150px;\n    }\n\n    .articlre-par-category-arrow-button.right-arrow {\n        right: 0px;\n    }\n\n    .articlre-par-category-arrow-button.left-arrow {\n        left: 0px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
